import { type MCPServerInfo } from '../../types';

const AvataxServer: MCPServerInfo = {
  serverId: 'AVATAX',
  name: 'AvaTax',
  slug: 'avatax',
  description:
    "Avalara's official remote MCP server for AvaTax — query tax calculation, transactions, and reporting data across your Avalara account.",
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.avalara.com/avatax'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default AvataxServer;
